/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ResponseForAgentHtmlPage extends models.BaseForAgentResponse {
    constructor() {
        super();
        this.setDiscriminator("HtmlPage");
    }

    getFixupPrototypeFunction() { return ResponseForAgentHtmlPage.fixupPrototype; }

    static newInstance(model: Partial<ResponseForAgentHtmlPage>): ResponseForAgentHtmlPage {
        let obj = Object.assign(new ResponseForAgentHtmlPage(), model);
        ResponseForAgentHtmlPage.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ResponseForAgentHtmlPage>): ResponseForAgentHtmlPage {
        if (!model) return null;
        return ResponseForAgentHtmlPage.newInstance(<ResponseForAgentHtmlPage> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ResponseForAgentHtmlPage) {
        if (!obj) return;

        models.ResponseForAgentHtmlPage.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ResponseForAgentHtmlPage): boolean {
        if (models.BaseForAgentResponse.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ResponseForAgentHtmlPage.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Self-contained OSCAR-styled HTML for a dashboard/report response
     */
    value: string;

}
